module.exports = __webpack_public_path__ + "img/richard-lounsbery-foundation.d90a4991.jpg";